export default __webpack_public_path__ + "static/media/top_cg_img@2x.9581347a.jpg";